const SEMVER_PATTERN = /^\d+\.\d+/;

export const parseAgentVersion = (rawVersion: string | undefined): string => {
  if (!rawVersion) return '0.0';
  const candidate = rawVersion.replace(/^.*\//, '').replace(/^v/, '');
  return SEMVER_PATTERN.test(candidate) ? candidate : '0.0';
};
